import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { getWorkFlowAutomationStoppedInstancesActions } from 'services/workflowAutomation/workflowAutomationRuleServices';

export default function useGetStoppedAutomation(instance_id) {
  const { automationId } = useParams();
  const [stoppedAutomationData, setStoppedAutomationData] = useState(null);

  const getAutomationData = () => {
    getWorkFlowAutomationStoppedInstancesActions(automationId, instance_id)
      .then((res) => {
        setStoppedAutomationData(res?.data);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  useEffect(() => {
    if (automationId && instance_id) {
      getAutomationData();
    }
  }, [automationId, instance_id]);

  return {
    stoppedAutomationData,
  };
}
